import React from 'react';
import './Card.css';

const Card = ({
  children,
  className = '',
  padding = 'default',
  variant = 'elevated',
  as: Component = 'div',
  ...props
}) => {
  const classes = [
    'card',
    `card--${variant}`,
    `card--padding-${padding}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <Component className={classes} {...props}>
      {children}
    </Component>
  );
};

// Sub-components for structured cards
Card.Header = ({ children, className = '', ...props }) => (
  <div className={`card__header ${className}`} {...props}>
    {children}
  </div>
);

Card.Title = ({ children, as: Component = 'h3', className = '', ...props }) => (
  <Component className={`card__title ${className}`} {...props}>
    {children}
  </Component>
);

Card.Description = ({ children, className = '', ...props }) => (
  <p className={`card__description ${className}`} {...props}>
    {children}
  </p>
);

Card.Body = ({ children, className = '', ...props }) => (
  <div className={`card__body ${className}`} {...props}>
    {children}
  </div>
);

Card.Footer = ({ children, className = '', ...props }) => (
  <div className={`card__footer ${className}`} {...props}>
    {children}
  </div>
);

export default Card;
